/* eslint-disable */
import { Model } from '@vuex-orm/core'

class CTTPostcode extends Model {
  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
    }
  }

  static list(options = {}) {
    return this.api().request({
      method: 'GET',
      url: `/chang-tt/postcodes`,
      ...options,
    }).then((res) => res.response.data)
  }
}

CTTPostcode.entity = 'postcode'

export default CTTPostcode